var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 42 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25254 51.1966C3.25254 51.1966 -10.4458 19.4844 18.3813 0.743164L20.8058 6.51342C21.8918 3.94517 23.9102 1.88349 26.4548 0.743164C26.4548 0.743164 24.4182 15.0718 41.729 16.1386C41.729 16.1386 40.0804 20.7694 29.6066 22.224C29.6066 22.224 12.3201 21.3512 7.78631 29.255C7.66509 29.255 2.42821 35.7041 3.25254 51.1966Z",
    fill: "url(#paint0_linear_198_6)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7288 23.436C41.7288 23.436 26.8667 23.9937 23.0845 36.0676C22.2703 39.6697 21.9039 43.3585 21.9935 47.0505C21.9935 47.0505 23.0845 66.4463 14.9625 70.3012C14.9625 70.3012 38.2133 71.7316 39.6437 56.9666C39.6437 56.9666 40.7347 52.2631 39.1103 39.9952C39.1103 40.0195 36.3707 29.0366 41.7288 23.436Z",
    fill: "url(#paint1_linear_198_6)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3345 25.9578C35.3494 26.5143 32.6079 27.9763 30.4824 30.1451C28.357 32.3139 26.9507 35.0843 26.4546 38.0802C28.1726 35.7421 30.494 33.9151 33.1704 32.7948C33.1704 32.7948 34.8675 38.2256 37.0496 39.7773C35.8989 35.1583 36.352 30.2854 38.3345 25.9578Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_198_6",
    x1: 0.00373528,
    y1: 25.9577,
    x2: 41.729,
    y2: 25.9577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#ED2124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15A29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_198_6",
    x1: 168.601,
    y1: 1231.18,
    x2: 483.578,
    y2: 1066.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#ED2124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15A29"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.431beb93d507f7f81a908d1f6b351e4f.svg";
export { ForwardRef as ReactComponent };